module.exports = __webpack_public_path__ + "img/avatar3.c8148660.svg";